/** 问号浮层提示（与 web-demo shell.js 一致，fixed 定位避免被表格 overflow 裁切） */
function tipFloatEl() {
  let f = document.getElementById('__tipfloat')
  if (f) return f
  f = document.createElement('div')
  f.id = '__tipfloat'
  document.body.appendChild(f)
  return f
}

function showTip(tipEl) {
  const box = tipEl.querySelector('.tip-box')
  if (!box) return
  const f = tipFloatEl()
  f.innerHTML = box.innerHTML
  f.style.display = 'block'
  const r = tipEl.getBoundingClientRect()
  const fw = f.offsetWidth
  const fh = f.offsetHeight
  const gap = 8
  let left = r.left + r.width / 2 - fw / 2
  let top = r.top - fh - gap
  if (top < 8) top = r.bottom + gap
  if (left < 8) left = 8
  if (left + fw > window.innerWidth - 8) left = window.innerWidth - 8 - fw
  f.style.left = `${left}px`
  f.style.top = `${top}px`
}

function hideTip() {
  const f = document.getElementById('__tipfloat')
  if (f) f.style.display = 'none'
}

export function initTipFloat() {
  document.addEventListener('mouseover', (e) => {
    const tip = e.target.closest && e.target.closest('.tip')
    if (tip) showTip(tip)
  })
  document.addEventListener('mouseout', (e) => {
    const tip = e.target.closest && e.target.closest('.tip')
    if (tip) hideTip()
  })
  window.addEventListener('scroll', hideTip, true)
  window.addEventListener('resize', hideTip)
}
